var _defs, _g, _a;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbPhase2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1298.35 1219.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .ib-disable-phase-2{\n        fill: #edeef0 !important; \n      }\n      .ib-disable-phase-2:hover {\n        pointer-events: none;\n        fill: #edeef0 !important; \n      }\n      .ib-diamond-disable-phase-2{\n        fill: #07DABE !important\n      }\n      .ib-diamond-disable-phase-2:hover {\n        pointer-events: none;\n        fill: #07DABE !important  \n      }\n      .ib-phase-2-1, .ib-phase-2-2, .ib-phase-2-3, .ib-phase-2-4 {\n        fill: #fff;\n      }\n\n      .ib-phase-2-1, .ib-phase-2-5, .ib-phase-2-6 {\n        stroke: rgba(0, 0, 0, 0);\n      }\n\n      .ib-phase-2-7 {\n        fill: url(#linear-gradient-ib-phase-2-3);\n      }\n\n      .ib-phase-2-7, .ib-phase-2-8, .ib-phase-2-9, .ib-phase-2-10, .ib-phase-2-4, .ib-phase-2-11 {\n        stroke: #008573;\n      }\n\n      .ib-phase-2-12, .ib-phase-2-13, .ib-phase-2-14, .ib-phase-2-15, .ib-phase-2-16, .ib-phase-2-17, .ib-phase-2-3, .ib-phase-2-18, .ib-phase-2-19, .ib-phase-2-20, .ib-phase-2-21 {\n        stroke-width: 0px;\n      }\n\n      .ib-phase-2-12, .ib-phase-2-8, .ib-phase-2-10 {\n        fill: #008573;\n      }\n\n      .ib-phase-2-2, .ib-phase-2-22 {\n        stroke: #4c535d;\n        stroke-width: .2px;\n      }\n\n      .ib-phase-2-23 {\n        fill: url(#linear-gradient-ib-phase-2-2);\n      }\n\n      .ib-phase-2-23, .ib-phase-2-24 {\n        stroke: #1071e5;\n      }\n\n      .ib-phase-2-22, .ib-phase-2-21 {\n        fill: #e81313;\n      }\n\n      .ib-phase-2-5 {\n        fill: #ffe342;\n      }\n\n      .ib-phase-2-13 {\n        fill: #e61e25;\n      }\n\n      .ib-phase-2-8, .ib-phase-2-24 {\n        stroke-width: .05px;\n      }\n\n      .ib-phase-2-15 {\n        fill: #ecf5fc;\n      }\n\n      .ib-phase-2-16, .ib-phase-2-11 {\n        fill: none;\n      }\n\n      .ib-phase-2-9 {\n        fill: url(#linear-gradient-ib-phase-2);\n      }\n\n      .ib-phase-2-17 {\n        fill: #333;\n      }\n\n      .ib-phase-2-24, .ib-phase-2-20 {\n        fill: #1071e5;\n      }\n\n      .ib-phase-2-6 {\n        fill: #1a3378;\n      }\n\n      .ib-phase-2-18 {\n        fill: #2f5496;\n      }\n\n      .ib-phase-2-19 {\n        fill: #3a414a;\n      }\n\n      .ib-phase-2-25 {\n        fill: #273777;\n        stroke: #273777;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-ib-phase-2",
    x1: 389.62,
    y1: 1444.46,
    x2: 389.62,
    y2: 1275.8,
    gradientTransform: "translate(193.89 1595.76) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008573"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-ib-phase-2-2",
    x1: -95.37,
    y1: 1409.46,
    x2: -95.37,
    y2: 1310.79,
    gradientTransform: "translate(193.89 1595.76) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#cfe4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-ib-phase-2-3",
    x1: 389.62,
    y1: 971.34,
    x2: 389.62,
    y2: 802.68,
    gradientTransform: "translate(193.89 1595.76) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008573"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ib-disable-phase-2",
    d: "M411.53,1126.36c0-3.31,2.69-6,6-6h330.27c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6h-330.28c-3.31,0-6-2.69-6-6v-86.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "U",
    className: "ib-phase-2-19",
    d: "M436.94,1158.81l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM434.36,1152.09l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "ib-phase-2-19",
    d: "M445.09,1145.64c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM445.7,1147.27c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V-2",
    "data-name": "V",
    className: "ib-phase-2-19",
    d: "M458.67,1145.64c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM459.28,1147.27c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "W",
    className: "ib-phase-2-19",
    d: "M482.85,1156.37c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM476.53,1155.21c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X",
    className: "ib-phase-2-19",
    d: "M496.02,1149.1c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "ib-phase-2-19",
    d: "M509.06,1147.27h-1.7l-.27-5.3h2.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-2",
    "data-name": "X",
    className: "ib-phase-2-19",
    d: "M519.65,1149.1c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "ib-phase-2-19",
    d: "M528.41,1159.08c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "ib-phase-2-19",
    d: "M544.09,1145.64c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM543.55,1157.45c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa-2",
    "data-name": "aa",
    className: "ib-phase-2-19",
    d: "M557.67,1145.64c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM557.13,1157.45c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "ib-phase-2-19",
    d: "M570.23,1145.64c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM570.17,1157.45c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "ib-phase-2-19",
    d: "M584.77,1147.74c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "ib-phase-2-19",
    d: "M589.11,1155.62c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "ib-phase-2-19",
    d: "M593.52,1143.13v-2.04h2.17v2.04h-2.17ZM593.52,1158.81v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "ib-phase-2-19",
    d: "M605.2,1145.64c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "ib-phase-2-19",
    d: "M622.86,1145.91c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM617.22,1157.32c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "V-3",
    "data-name": "V",
    className: "ib-phase-2-19",
    d: "M636.98,1145.64c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM637.59,1147.27c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-2",
    "data-name": "ab",
    className: "ib-phase-2-19",
    d: "M651.58,1145.64c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM651.51,1157.45c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "ib-phase-2-19",
    d: "M664.89,1147.34c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-2",
    "data-name": "Z",
    className: "ib-phase-2-19",
    d: "M676.3,1159.08c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "ib-phase-2-19",
    d: "M698.43,1147.34c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "ib-phase-2-19",
    d: "M711.27,1145.64c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM714.8,1151.14c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-2",
    "data-name": "af",
    className: "ib-phase-2-19",
    d: "M726,1145.64c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-2",
    "data-name": "ad",
    className: "ib-phase-2-19",
    d: "M735.64,1155.62c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-2",
    "data-name": "Y",
    className: "ib-phase-2-19",
    d: "M741.62,1147.27h-1.7l-.27-5.3h2.24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ad-3",
    "data-name": "ad",
    className: "ib-phase-2-19",
    d: "M477.24,1184.95c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-3",
    "data-name": "ab",
    className: "ib-phase-2-19",
    d: "M486.82,1174.97c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM486.75,1186.79c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac-2",
    "data-name": "ac",
    className: "ib-phase-2-19",
    d: "M508.14,1177.08c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-2",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M515.27,1174.97c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM518.8,1180.47c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "ib-phase-2-19",
    d: "M523.69,1188.15v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-3",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M534.21,1174.97c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM537.74,1180.47c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "ib-phase-2-19",
    d: "M548.34,1188.15h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-2",
    "data-name": "W",
    className: "ib-phase-2-19",
    d: "M562.8,1185.7c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM556.48,1184.55c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-3",
    "data-name": "af",
    className: "ib-phase-2-19",
    d: "M574.75,1174.97c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-4",
    "data-name": "ad",
    className: "ib-phase-2-19",
    d: "M584.39,1184.95c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai-2",
    "data-name": "ai",
    className: "ib-phase-2-19",
    d: "M608.23,1176.67c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-3",
    "data-name": "W",
    className: "ib-phase-2-19",
    d: "M623.84,1185.7c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM617.53,1184.55c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-5",
    "data-name": "ad",
    className: "ib-phase-2-19",
    d: "M631.85,1184.95c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-4",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M641.43,1174.97c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM644.96,1180.47c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-3",
    "data-name": "ac",
    className: "ib-phase-2-19",
    d: "M655.96,1177.08c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-2",
    "data-name": "ae",
    className: "ib-phase-2-19",
    d: "M657.93,1172.46v-2.04h2.17v2.04h-2.17ZM657.93,1188.15v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-4",
    "data-name": "W",
    className: "ib-phase-2-19",
    d: "M671.24,1185.7c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM664.92,1184.55c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-2",
    "data-name": "ak",
    className: "ib-phase-2-19",
    d: "M676.87,1188.15v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-3",
    "data-name": "X",
    className: "ib-phase-2-19",
    d: "M689.77,1178.44c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect-1",
    className: "ib-phase-2-4",
    d: "M411.97,6.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6V6.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "ib-phase-2-19",
    d: "M520.66,55.65v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-4",
    "data-name": "af",
    className: "ib-phase-2-19",
    d: "M533.15,42.48c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-3",
    "data-name": "ae",
    className: "ib-phase-2-19",
    d: "M540.42,39.97v-2.04h2.17v2.04h-2.17ZM540.42,55.65v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-6",
    "data-name": "ad",
    className: "ib-phase-2-19",
    d: "M548.16,52.46c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-4",
    "data-name": "ae",
    className: "ib-phase-2-19",
    d: "M552.57,39.97v-2.04h2.17v2.04h-2.17ZM552.57,55.65v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-5",
    "data-name": "W",
    className: "ib-phase-2-19",
    d: "M565.88,53.21c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM559.57,52.05c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-7",
    "data-name": "ad",
    className: "ib-phase-2-19",
    d: "M573.89,52.46c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-5",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M583.47,42.48c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM587,47.98c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "ib-phase-2-19",
    d: "M613.34,55.65l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "ib-phase-2-19",
    d: "M619.39,55.65v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "ib-phase-2-19",
    d: "M646.75,43.63c-.07,2.78-1.56,4.35-4.07,4.75l4.75,7.27h-2.58l-4.41-6.99h-5.23v6.99h-2.24v-16.84c5.98.2,13.92-1.43,13.78,4.82ZM635.21,46.89c4.07-.14,9.3.88,9.3-3.19s-5.43-2.85-9.3-3.06v6.25"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect-2",
    className: "ib-phase-2-9",
    d: "M578.13,153.96c3.39-1.67,7.37-1.67,10.76,0l160.36,79.02c1.46.73,2.06,2.51,1.33,3.97-.29.58-.75,1.04-1.33,1.33l-160.35,79.04c-3.39,1.67-7.38,1.67-10.77,0l-160.36-79.02c-1.46-.73-2.06-2.51-1.33-3.97.29-.58.75-1.04,1.33-1.33l160.36-79.04Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "ib-phase-2-3",
    d: "M531.95,240.45l.14-13.85-4.35,13.85h-2.51l-4.28-13.85.14,13.85h-3.12v-16.84h4.75l3.8,12.56,3.87-12.56h4.69v16.84h-3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "ib-phase-2-3",
    d: "M538.27,240.45v-16.84h3.53v14.12h9.03v2.72h-12.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "ib-phase-2-3",
    d: "M567.81,228.64c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM556.67,231.35c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "ib-phase-2-3",
    d: "M585.87,240.45h-3.6l-6.25-16.84h3.73l4.35,13.99c1.15-4.89,2.85-9.3,4.28-13.99h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "ib-phase-2-3",
    d: "M603.39,237.19c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM600.33,232.51c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "ib-phase-2-3",
    d: "M613.57,230.27c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "ib-phase-2-3",
    d: "M619.89,227.28c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM621.04,238.42c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "ib-phase-2-3",
    d: "M630.48,225.24v-2.51h3.4v2.51h-3.4ZM630.48,240.45v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "ib-phase-2-3",
    d: "M648.47,236.18c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az",
    className: "ib-phase-2-3",
    d: "M656.96,240.25c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-11",
    d: "M583.1,100.16l.3,37.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M583.6,100.18h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-10",
    d: "M583.5,152.72l-4.75-14.23,9.27-.07-4.52,14.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-6",
    className: "ib-phase-2-23",
    d: "M.5,192.3c0-3.31,2.69-6,6-6h184.04c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-86.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aA",
    className: "ib-phase-2-3",
    d: "M39.23,229.09c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-2",
    "data-name": "au",
    className: "ib-phase-2-3",
    d: "M56.61,238.19c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM53.55,233.5c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-3",
    "data-name": "au",
    className: "ib-phase-2-3",
    d: "M70.19,238.19c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM67.13,233.5c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB",
    className: "ib-phase-2-3",
    d: "M79.63,224.61c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM83.16,232.83c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC",
    className: "ib-phase-2-3",
    d: "M102.04,230.79c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD",
    className: "ib-phase-2-3",
    d: "M118.2,239.14c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM114.94,239.34c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE",
    className: "ib-phase-2-3",
    d: "M132.05,232.08c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-4",
    "data-name": "au",
    className: "ib-phase-2-3",
    d: "M148.89,238.19c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM145.83,233.5c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aF",
    className: "ib-phase-2-3",
    d: "M158.26,241.45v-2.51h4.14v-11.48l-4.01,2.51v-2.58l4.21-2.78h3.12v14.33h3.87v2.51h-11.34"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ib-disable-phase-2",
    d: "M1017.3,187.06c0-3.31,2.69-6,6-6h228c3.31,0,6,2.69,6,6v108c0,3.31-2.69,6-6,6h-228c-3.31,0-6-2.69-6-6v-108Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "U-2",
    "data-name": "U",
    className: "ib-phase-2-19",
    d: "M1067.72,229.69l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM1065.14,222.97l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-2",
    "data-name": "ah",
    className: "ib-phase-2-19",
    d: "M1076.62,218.21c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-8",
    "data-name": "ad",
    className: "ib-phase-2-19",
    d: "M1086.33,226.5c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-5",
    "data-name": "ae",
    className: "ib-phase-2-19",
    d: "M1090.74,214v-2.04h2.17v2.04h-2.17ZM1090.74,229.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-4",
    "data-name": "ab",
    className: "ib-phase-2-19",
    d: "M1101.26,216.52c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM1101.2,228.33c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-5",
    "data-name": "af",
    className: "ib-phase-2-19",
    d: "M1116,216.52c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ah-3",
    "data-name": "ah",
    className: "ib-phase-2-19",
    d: "M1134.94,218.21c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG",
    className: "ib-phase-2-19",
    d: "M1147.84,218.21c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-6",
    "data-name": "W",
    className: "ib-phase-2-19",
    d: "M1163.8,227.25c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM1157.49,226.09c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-6",
    "data-name": "af",
    className: "ib-phase-2-19",
    d: "M1175.75,216.52c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-2",
    "data-name": "ag",
    className: "ib-phase-2-19",
    d: "M1193.41,216.79c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM1187.77,228.2c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-6",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M1201.76,216.52c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1205.29,222.02c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-4",
    "data-name": "X",
    className: "ib-phase-2-19",
    d: "M1217.72,219.98c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac-4",
    "data-name": "ac",
    className: "ib-phase-2-19",
    d: "M1100.31,247.96c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-7",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M1107.44,245.85c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1110.97,251.35c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH",
    className: "ib-phase-2-19",
    d: "M1124.08,256.92c-.75,1.49-1.97,2.38-4.07,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.01,1.15-6.72,4.75-6.79,2.17-.07,3.26.95,4.07,2.24,0-.75-.07-1.63.14-2.17h2.04l-.07,18.2h-2.17l.07-7.2ZM1120.55,257.6c2.78,0,3.46-2.24,3.46-5.16s-.54-4.96-3.4-4.96-3.12,2.38-3.12,5.09.34,5.02,3.06,5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-3",
    "data-name": "Z",
    className: "ib-phase-2-19",
    d: "M1133.52,259.29c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-6",
    "data-name": "ae",
    className: "ib-phase-2",
    d: "M1143.02,243.34v-2.04h2.17v2.04h-2.17ZM1143.02,259.02v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-5",
    "data-name": "ac",
    className: "ib-phase-2-19",
    d: "M1154.5,247.96c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-8",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M1161.63,245.85c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1165.16,251.35c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V-4",
    "data-name": "V",
    className: "ib-phase-2-19",
    d: "M1174.19,245.85c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM1174.8,247.48c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-24",
    d: "M237.05,236.13h-23.63v-1h23.63v1ZM415.11,236.13h-16.86v-1h16.87v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-20",
    d: "M415.6,235.63l.07.5h-.57v-1h.57l-.07.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-24",
    d: "M415.64,235.63l.06.53h-.62v-1.05h.62l-.06.52ZM415.14,235.16v.95h.5l-.05-.48.04-.47h-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-20",
    d: "M212.92,240.26l-14.27-4.63,14.27-4.63v9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-24",
    d: "M213.42,240.96l-16.4-5.33,16.4-5.32v10.65ZM200.27,235.63l12.15,3.95v-7.9l-12.15,3.95Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI",
    className: "ib-phase-2-14",
    d: "M294.6,214.04c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM283.46,216.76c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ",
    className: "ib-phase-2-14",
    d: "M308.45,222.6c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM305.39,217.91c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK",
    className: "ib-phase-2-14",
    d: "M318.16,225.86h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL",
    className: "ib-phase-2-14",
    d: "M324.74,210.65v-2.51h3.4v2.51h-3.4ZM324.74,225.86v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM",
    className: "ib-phase-2-14",
    d: "M339.14,216.48c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-2",
    "data-name": "aJ",
    className: "ib-phase-2-14",
    d: "M355.98,222.6c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM352.92,217.91c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aN",
    className: "ib-phase-2-14",
    d: "M246.08,252.88c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM242.82,253.08c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO",
    className: "ib-phase-2-14",
    d: "M259.8,242.02c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP",
    className: "ib-phase-2-14",
    d: "M271.48,242.02c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM272.63,253.15c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI-2",
    "data-name": "aI",
    className: "ib-phase-2-14",
    d: "M303.46,243.37c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM292.32,246.09c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-3",
    "data-name": "aJ",
    className: "ib-phase-2-14",
    d: "M317.31,251.93c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM314.25,247.24c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-2",
    "data-name": "aM",
    className: "ib-phase-2-14",
    d: "M327.63,245.82c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ",
    className: "ib-phase-2-14",
    d: "M337.68,255.46c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR",
    className: "ib-phase-2-14",
    d: "M355.94,242.02c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51ZM354.52,253.15c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS",
    className: "ib-phase-2-14",
    d: "M376.59,244.53c-3.6.61-1.9,6.79-2.31,10.66h-3.33v-7.27c.07-1.83-.34-3.33-1.97-3.4-3.6.68-1.83,6.79-2.24,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.68-3.6,6.86-3.8,7.33,0,.88-1.49,1.63-2.92,4.01-2.85,5.57.07,3.46,7.88,3.87,13.17h-3.33v-7.27c-.07-1.7-.34-3.26-1.97-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-2",
    "data-name": "aL",
    className: "ib-phase-2-14",
    d: "M385.07,239.98v-2.51h3.4v2.51h-3.4ZM385.07,255.19v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT",
    className: "ib-phase-2-14",
    d: "M397.98,254.98c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M1000.4,235.46v1h-39.07v-1h39.07ZM751.9,236.13v-1h54.96v1h-54.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-12",
    d: "M751.92,236.13h-.57l.06-.5-.05-.5h.57v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M751.95,236.16h-.63l.06-.53-.06-.52h.63v1.05ZM751.38,235.16l.05.47-.05.48h.52v-.95h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-12",
    d: "M1015.17,235.96l-14.27,4.6v-9.27l14.27,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M1016.8,235.96l-16.4,5.3v-10.64l16.4,5.34ZM1001.4,239.89l12.15-3.94-12.15-3.96v7.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aU",
    className: "ib-phase-2-14",
    d: "M840.75,226.01l-1.49-4.28h-6.38l-1.49,4.28h-3.53l6.11-16.84h4.14l6.11,16.84h-3.46ZM838.51,219.09l-2.44-7.33c-.68,2.58-1.63,4.89-2.44,7.33h4.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV",
    className: "ib-phase-2-14",
    d: "M853.99,212.84c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM852.56,223.97c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-2",
    "data-name": "aV",
    className: "ib-phase-2-14",
    d: "M868.86,212.84c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM867.43,223.97c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW",
    className: "ib-phase-2-14",
    d: "M883.73,215.83c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX",
    className: "ib-phase-2-14",
    d: "M891.54,212.84c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM891.47,223.97c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK-2",
    "data-name": "aK",
    className: "ib-phase-2-14",
    d: "M907.63,226.01h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-4",
    "data-name": "aJ",
    className: "ib-phase-2-14",
    d: "M925.08,222.75c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM922.02,218.07c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-2",
    "data-name": "aP",
    className: "ib-phase-2-14",
    d: "M932.07,212.84c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM933.23,223.97c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aY",
    className: "ib-phase-2-14",
    d: "M822.55,255.34h-3.53l-2.65-10.52-2.72,10.52h-3.53l-3.33-12.9h3.12l2.17,9.85c.61-3.53,1.63-6.59,2.44-9.85h3.6l2.51,9.85,2.17-9.85h3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-3",
    "data-name": "aL",
    className: "ib-phase-2-14",
    d: "M827.57,240.14v-2.51h3.4v2.51h-3.4ZM827.57,255.34v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-2",
    "data-name": "aT",
    className: "ib-phase-2-14",
    d: "M840.48,255.14c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ",
    className: "ib-phase-2-14",
    d: "M848.49,244.68c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ba",
    className: "ib-phase-2-14",
    d: "M875.31,251.07c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-2",
    "data-name": "aZ",
    className: "ib-phase-2-14",
    d: "M883.73,244.68c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN-2",
    "data-name": "aN",
    className: "ib-phase-2-14",
    d: "M899.89,253.04c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM896.63,253.24c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO-2",
    "data-name": "aO",
    className: "ib-phase-2-14",
    d: "M913.61,242.17c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb",
    className: "ib-phase-2-14",
    d: "M932.55,254.94c.75,5.98-8.15,7.2-11.14,3.53-.27-.41-.41-.88-.54-1.43l3.33-.41c.2,1.09,1.09,1.63,2.31,1.7,2.72,0,2.85-2.51,2.72-5.36-.75,1.49-2.04,2.38-4.14,2.38-3.6,0-4.75-2.92-4.75-6.59s1.22-6.52,4.96-6.59c2.04,0,3.12.95,4.01,2.31l.14-2.04h3.19l-.07,12.49ZM926.44,252.97c2.17,0,2.78-1.83,2.78-4.28s-.61-4.21-2.72-4.21-2.65,1.97-2.72,4.28c0,2.44.61,4.21,2.65,4.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-5",
    "data-name": "aJ",
    className: "ib-phase-2-14",
    d: "M946.74,252.09c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM943.69,247.4c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-3",
    "data-name": "aM",
    className: "ib-phase-2-14",
    d: "M957.06,245.97c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M584.86,422.08h-1v-28.86h1v28.86ZM584.01,334.56h-1v-17.13h1v17.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M584,317.44h-1v-3.5h1v3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-12",
    d: "M584.36,436.86l-4.63-14.28h9.27l-4.64,14.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M584.36,438.46l-5.32-16.38h10.65l-5.33,16.38ZM580.42,423.08l3.94,12.15,3.95-12.15h-7.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x-2",
    "data-name": "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aU-2",
    "data-name": "aU",
    className: "ib-phase-2-14",
    d: "M540.16,354.11l-1.49-4.28h-6.38l-1.49,4.28h-3.53l6.11-16.84h4.14l6.11,16.84h-3.46ZM537.92,347.18l-2.44-7.33c-.68,2.58-1.63,4.89-2.44,7.33h4.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-3",
    "data-name": "aV",
    className: "ib-phase-2-14",
    d: "M553.4,340.94c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM551.98,352.07c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-4",
    "data-name": "aV",
    className: "ib-phase-2-14",
    d: "M568.27,340.94c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM566.85,352.07c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-2",
    "data-name": "aW",
    className: "ib-phase-2-14",
    d: "M583.14,343.93c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-2",
    "data-name": "aX",
    className: "ib-phase-2-14",
    d: "M590.95,340.94c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM590.88,352.07c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK-3",
    "data-name": "aK",
    className: "ib-phase-2-14",
    d: "M607.04,354.11h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-6",
    "data-name": "aJ",
    className: "ib-phase-2-14",
    d: "M624.49,350.85c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM621.44,346.17c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-3",
    "data-name": "aP",
    className: "ib-phase-2-14",
    d: "M631.49,340.94c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM632.64,352.07c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bc",
    className: "ib-phase-2-14",
    d: "M507.81,368.1c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-3",
    "data-name": "aX",
    className: "ib-phase-2-14",
    d: "M515.14,370.27c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM515.07,381.41c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-3",
    "data-name": "aW",
    className: "ib-phase-2-14",
    d: "M531.71,373.26c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bd",
    className: "ib-phase-2-14",
    d: "M540.47,366.6c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM544,374.82c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-4",
    "data-name": "aW",
    className: "ib-phase-2-14",
    d: "M564.3,373.26c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-4",
    "data-name": "aX",
    className: "ib-phase-2-14",
    d: "M572.11,370.27c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM572.04,381.41c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-4",
    "data-name": "aP",
    className: "ib-phase-2-14",
    d: "M585.49,370.27c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM586.64,381.41c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-2",
    "data-name": "aQ",
    className: "ib-phase-2-14",
    d: "M600.15,383.72c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-2",
    "data-name": "ba",
    className: "ib-phase-2-14",
    d: "M622.15,379.17c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-3",
    "data-name": "aT",
    className: "ib-phase-2-14",
    d: "M630.64,383.24c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-4",
    "data-name": "aL",
    className: "ib-phase-2-14",
    d: "M632.61,368.23v-2.51h3.4v2.51h-3.4ZM632.61,383.44v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-5",
    "data-name": "aX",
    className: "ib-phase-2-14",
    d: "M645.17,370.27c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM645.1,381.41c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO-3",
    "data-name": "aO",
    className: "ib-phase-2-14",
    d: "M661.74,370.27c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect-3",
    className: "ib-phase-2-4",
    d: "M412.4,444.96c0-3.31,2.69-6,6-6h330.24c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.24c-3.31,0-6-2.69-6-6v-86.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "h-2",
    "data-name": "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am-2",
    "data-name": "am",
    className: "ib-phase-2-19",
    d: "M482.47,494.11v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-7",
    "data-name": "af",
    className: "ib-phase-2-19",
    d: "M494.97,480.94c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-7",
    "data-name": "ae",
    className: "ib-phase-2-19",
    d: "M502.23,478.43v-2.04h2.17v2.04h-2.17ZM502.23,494.11v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-9",
    "data-name": "ad",
    className: "ib-phase-2-19",
    d: "M509.97,490.92c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-8",
    "data-name": "ae",
    className: "ib-phase-2-19",
    d: "M514.39,478.43v-2.04h2.17v2.04h-2.17ZM514.39,494.11v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-7",
    "data-name": "W",
    className: "ib-phase-2-19",
    d: "M527.7,491.67c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM521.38,490.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-10",
    "data-name": "ad",
    className: "ib-phase-2-19",
    d: "M535.71,490.92c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-9",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M545.28,480.94c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM548.81,486.44c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "be",
    className: "ib-phase-2-19",
    d: "M573.26,481.96c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-10",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M583.24,480.94c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM586.77,486.44c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-6",
    "data-name": "ac",
    className: "ib-phase-2-19",
    d: "M597.77,483.05c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-11",
    "data-name": "ad",
    className: "ib-phase-2-19",
    d: "M602.12,490.92c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-9",
    "data-name": "ae",
    className: "ib-phase-2-19",
    d: "M606.53,478.43v-2.04h2.17v2.04h-2.17ZM606.53,494.11v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf",
    className: "ib-phase-2-19",
    d: "M617.12,478.23c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-10",
    "data-name": "ae",
    className: "ib-phase-2-19",
    d: "M618.68,478.43v-2.04h2.17v2.04h-2.17ZM618.68,494.11v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-4",
    "data-name": "ah",
    className: "ib-phase-2-19",
    d: "M628.94,482.64c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-8",
    "data-name": "W",
    className: "ib-phase-2-19",
    d: "M644.21,491.67c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM637.9,490.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-12",
    "data-name": "ad",
    className: "ib-phase-2-19",
    d: "M652.23,490.92c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-11",
    "data-name": "ae",
    className: "ib-phase-2-19",
    d: "M656.64,478.43v-2.04h2.17v2.04h-2.17ZM656.64,494.11v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-5",
    "data-name": "ab",
    className: "ib-phase-2-19",
    d: "M667.17,480.94c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM667.1,492.76c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-8",
    "data-name": "af",
    className: "ib-phase-2-19",
    d: "M681.9,480.94c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect-4",
    className: "ib-phase-2-7",
    d: "M578.13,627.06c3.39-1.67,7.37-1.67,10.76,0l160.36,79.03c1.46.73,2.06,2.51,1.33,3.97-.29.58-.75,1.04-1.33,1.33l-160.35,79.04c-3.39,1.67-7.38,1.67-10.77,0l-160.36-79.02c-1.46-.73-2.06-2.51-1.33-3.97.29-.58.75-1.04,1.33-1.33l160.36-79.05Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    className: "ib-phase-2-3",
    d: "M472.78,705.08c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-5",
    "data-name": "au",
    className: "ib-phase-2-3",
    d: "M498.38,710.31c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM495.32,705.62c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-2",
    "data-name": "av",
    className: "ib-phase-2-3",
    d: "M508.56,703.38c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-2",
    "data-name": "az",
    className: "ib-phase-2-3",
    d: "M516.71,713.36c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-2",
    "data-name": "ax",
    className: "ib-phase-2-3",
    d: "M518.68,698.36v-2.51h3.4v2.51h-3.4ZM518.68,713.57v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh",
    className: "ib-phase-2-3",
    d: "M531.99,698.22c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-3",
    "data-name": "ax",
    className: "ib-phase-2-3",
    d: "M533.55,698.36v-2.51h3.4v2.51h-3.4ZM533.55,713.57v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-2",
    "data-name": "ay",
    className: "ib-phase-2-3",
    d: "M551.54,709.29c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-2",
    "data-name": "aD",
    className: "ib-phase-2-3",
    d: "M561.25,711.26c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM557.99,711.46c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-3",
    "data-name": "az",
    className: "ib-phase-2-3",
    d: "M573.61,713.36c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-4",
    "data-name": "ax",
    className: "ib-phase-2-3",
    d: "M575.58,698.36v-2.51h3.4v2.51h-3.4ZM575.58,713.57v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi",
    className: "ib-phase-2-3",
    d: "M588.14,700.39c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM588.07,711.53c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj",
    className: "ib-phase-2-3",
    d: "M604.71,700.39c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-2",
    "data-name": "at",
    className: "ib-phase-2-3",
    d: "M627.19,713.57h-3.6l-6.25-16.84h3.73l4.35,13.99c1.15-4.89,2.85-9.3,4.28-13.99h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-6",
    "data-name": "au",
    className: "ib-phase-2-3",
    d: "M644.7,710.31c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM641.65,705.62c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-3",
    "data-name": "av",
    className: "ib-phase-2-3",
    d: "M654.89,703.38c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-2",
    "data-name": "aw",
    className: "ib-phase-2-3",
    d: "M661.2,700.39c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM662.36,711.53c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-5",
    "data-name": "ax",
    className: "ib-phase-2-3",
    d: "M671.8,698.36v-2.51h3.4v2.51h-3.4ZM671.8,713.57v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-3",
    "data-name": "ay",
    className: "ib-phase-2-3",
    d: "M689.79,709.29c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-4",
    "data-name": "az",
    className: "ib-phase-2-3",
    d: "M698.28,713.36c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-11",
    d: "M583.5,538.63v72.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M584,538.64h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-10",
    d: "M583.5,625.83l-4.6-14.27h9.27l-4.67,14.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M99.02,702.73l.07.88.2.83.32.8.45.74.57.65.65.56.73.46.8.32.83.2.88.07h151.78v1H104.5l-1-.1-.98-.23-.95-.4-.87-.52-.77-.67-.67-.77-.53-.86-.4-.94-.23-1-.08-1v-400.89h1v400.87ZM415.12,708.25v1h-16.63v-1h16.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-12",
    d: "M415.6,708.76l.07.5h-.57v-1h.57l-.07.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M415.64,708.76l.06.5h-.62v-1.04h.62l-.06.54ZM415.14,708.26v.96h.5l-.05-.47.04-.5h-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-12",
    d: "M103.16,301.36h-9.26l4.62-14.28,4.64,14.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M103.85,301.86h-10.65l5.32-16.4,5.33,16.4ZM94.58,300.86h7.9l-3.96-12.16-3.94,12.16Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bk",
    className: "ib-phase-2-14",
    d: "M268.19,713.64l-7.33-12.97c.41,3.94.14,8.69.2,12.97h-3.12v-16.84h4.01l7.47,13.1c-.41-3.94-.14-8.76-.2-13.1h3.12v16.84h-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX-6",
    "data-name": "aX",
    className: "ib-phase-2-14",
    d: "M281.36,700.46c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM281.3,711.6c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-4",
    "data-name": "aT",
    className: "ib-phase-2-14",
    d: "M296.57,713.43c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ba-3",
    "data-name": "ba",
    className: "ib-phase-2-14",
    d: "M316.54,709.36c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-7",
    "data-name": "aJ",
    className: "ib-phase-2-14",
    d: "M329.78,710.38c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM326.72,705.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-5",
    "data-name": "aW",
    className: "ib-phase-2-14",
    d: "M339.96,703.45c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-5",
    "data-name": "aT",
    className: "ib-phase-2-14",
    d: "M348.11,713.43c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-5",
    "data-name": "aL",
    className: "ib-phase-2-14",
    d: "M350.08,698.43v-2.51h3.4v2.51h-3.4ZM350.08,713.64v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-2",
    "data-name": "bc",
    className: "ib-phase-2-14",
    d: "M363.39,698.29c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-6",
    "data-name": "aL",
    className: "ib-phase-2-14",
    d: "M364.95,698.43v-2.51h3.4v2.51h-3.4ZM364.95,713.64v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-8",
    "data-name": "aJ",
    className: "ib-phase-2-14",
    d: "M382.6,710.38c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM379.55,705.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-5",
    "data-name": "aP",
    className: "ib-phase-2-14",
    d: "M389.6,700.46c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM390.75,711.6c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M876.8,709.26h-128.3v-1h128.3v1ZM1292.8,240.66l1,.23.94.4.87.52.78.67.67.77.53.86.4.94.23,1,.1,1v455.71l-.1,1-.23,1-.4.94-.52.87-.67.78-.77.67-.86.53-.94.4-1,.23-1,.1h-168.33v-1h168.27l.88-.08.84-.2.78-.33.74-.46.65-.57.56-.65.46-.74.32-.8.2-.83.07-.88V247.1l-.08-.88-.2-.84-.33-.78-.47-.74-.56-.66-.65-.56-.74-.45-.8-.32-.83-.2-.88-.07h-17.6v-1h17.64l1.03.06ZM748.5,709.26h-3.52v-1h3.5l.02,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-12",
    d: "M1273.67,245.71l-14.27-4.64,14.27-4.62v9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M1274.17,246.4l-16.38-5.33,16.37-5.3v10.63ZM1261.02,241.07l12.15,3.96v-7.9l-12.15,3.94Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI-3",
    "data-name": "aI",
    className: "ib-phase-2-14",
    d: "M893.11,701.82c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM881.98,704.54c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-9",
    "data-name": "aJ",
    className: "ib-phase-2-14",
    d: "M906.97,710.38c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM903.91,705.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK-4",
    "data-name": "aK",
    className: "ib-phase-2-14",
    d: "M916.68,713.64h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-7",
    "data-name": "aL",
    className: "ib-phase-2-14",
    d: "M923.26,698.43v-2.51h3.4v2.51h-3.4ZM923.26,713.64v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-4",
    "data-name": "aM",
    className: "ib-phase-2-14",
    d: "M937.66,704.26c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-10",
    "data-name": "aJ",
    className: "ib-phase-2-14",
    d: "M954.5,710.38c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM951.44,705.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aN-3",
    "data-name": "aN",
    className: "ib-phase-2-14",
    d: "M971.34,711.33c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM968.08,711.53c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO-4",
    "data-name": "aO",
    className: "ib-phase-2-14",
    d: "M985.05,700.46c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-6",
    "data-name": "aP",
    className: "ib-phase-2-14",
    d: "M996.73,700.46c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM997.89,711.6c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI-4",
    "data-name": "aI",
    className: "ib-phase-2-14",
    d: "M1028.71,701.82c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM1017.58,704.54c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-11",
    "data-name": "aJ",
    className: "ib-phase-2-14",
    d: "M1042.57,710.38c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM1039.51,705.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-5",
    "data-name": "aM",
    className: "ib-phase-2-14",
    d: "M1052.89,704.26c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-3",
    "data-name": "aQ",
    className: "ib-phase-2-14",
    d: "M1062.94,713.91c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-2",
    "data-name": "aR",
    className: "ib-phase-2-14",
    d: "M1081.2,700.46c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51ZM1079.77,711.6c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-2",
    "data-name": "aS",
    className: "ib-phase-2-14",
    d: "M1101.84,702.97c-3.6.61-1.9,6.79-2.31,10.66h-3.33v-7.27c.07-1.83-.34-3.33-1.97-3.4-3.6.68-1.83,6.79-2.24,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.68-3.6,6.86-3.8,7.33,0,.88-1.49,1.63-2.92,4.01-2.85,5.57.07,3.46,7.88,3.87,13.17h-3.33v-7.27c-.07-1.7-.34-3.26-1.97-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-8",
    "data-name": "aL",
    className: "ib-phase-2-14",
    d: "M1110.33,698.43v-2.51h3.4v2.51h-3.4ZM1110.33,713.64v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-6",
    "data-name": "aT",
    className: "ib-phase-2-14",
    d: "M1123.23,713.43c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect-5",
    className: "ib-phase-2-4",
    d: "M412.4,906.36c0-3.31,2.69-6,6-6h330.24c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6h-330.24c-3.31,0-6-2.69-6-6v-86.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bl",
    className: "ib-phase-2-19",
    d: "M445.09,940.56v6.25h9.37v1.9h-9.37v6.79h-2.24v-16.84h11.88v1.9h-9.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-12",
    "data-name": "ae",
    className: "ib-phase-2-19",
    d: "M457.32,939.81v-2.04h2.17v2.04h-2.17ZM457.32,955.5v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-9",
    "data-name": "af",
    className: "ib-phase-2-19",
    d: "M469,942.33c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-9",
    "data-name": "W",
    className: "ib-phase-2-19",
    d: "M484.21,953.06c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM477.89,951.9c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-3",
    "data-name": "ak",
    className: "ib-phase-2-19",
    d: "M489.84,955.5v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    id: "X-5",
    "data-name": "X",
    className: "ib-phase-2-19",
    d: "M509.53,945.79c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-13",
    "data-name": "ad",
    className: "ib-phase-2-19",
    d: "M516.59,952.31c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-11",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M526.17,942.33c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM529.7,947.83c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa-3",
    "data-name": "aa",
    className: "ib-phase-2-19",
    d: "M540.77,942.33c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM540.22,954.14c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-6",
    "data-name": "X",
    className: "ib-phase-2-19",
    d: "M555.71,945.79c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bm",
    className: "ib-phase-2-19",
    d: "M573.36,942.33c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM572.82,954.14c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-12",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M585.92,942.33c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM589.45,947.83c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-2",
    "data-name": "bf",
    className: "ib-phase-2-19",
    d: "M599.57,939.61c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-6",
    "data-name": "ab",
    className: "ib-phase-2-19",
    d: "M606.29,942.33c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM606.22,954.14c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-7",
    "data-name": "ac",
    className: "ib-phase-2-19",
    d: "M620.82,944.43c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-13",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M627.95,942.33c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM631.48,947.83c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bn",
    className: "ib-phase-2-19",
    d: "M651.24,955.77c-5.57,0-8.22-3.26-8.49-8.76-.34-7.27,6.79-10.46,13.1-7.54,1.15.54,1.97,1.7,2.51,2.92l-2.17.61c-.88-1.7-2.51-2.72-5.16-2.72-4.14,0-5.98,2.65-5.98,6.72s1.97,6.79,6.18,6.86c2.38,0,4.21-.75,5.36-1.83v-3.06h-5.02v-1.9h7.13v5.84c-1.7,1.7-4.14,2.85-7.47,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-7",
    "data-name": "ab",
    className: "ib-phase-2-19",
    d: "M667.34,942.33c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM667.27,954.14c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo",
    className: "ib-phase-2-19",
    d: "M675.21,949.93v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-2",
    "data-name": "ao",
    className: "ib-phase-2-19",
    d: "M684.24,955.5v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-13",
    "data-name": "ae",
    className: "ib-phase-2-19",
    d: "M697.42,939.81v-2.04h2.17v2.04h-2.17ZM697.42,955.5v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-2",
    "data-name": "al",
    className: "ib-phase-2-19",
    d: "M708.48,955.5h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-14",
    "data-name": "aj",
    className: "ib-phase-2-19",
    d: "M720.16,942.33c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM723.69,947.83c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M584,883.46h-1v-41.07h1v41.07ZM584,813.06h-1v-22.5h1v22.5ZM584,790.56h-1v-3.5h1v3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-12",
    d: "M583.5,898.23l-4.6-14.27h9.27l-4.67,14.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M583.5,899.86l-5.3-16.4h10.63l-5.33,16.4ZM579.56,884.46l3.95,12.15,3.96-12.14h-7.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bp",
    className: "ib-phase-2-17",
    d: "M538.63,824.13c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq",
    className: "ib-phase-2-17",
    d: "M564.23,829.35c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM561.18,824.67c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br",
    className: "ib-phase-2-17",
    d: "M574.42,822.43c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs",
    className: "ib-phase-2-17",
    d: "M582.57,832.41c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt",
    className: "ib-phase-2-17",
    d: "M584.53,817.4v-2.51h3.4v2.51h-3.4ZM584.53,832.61v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu",
    className: "ib-phase-2-17",
    d: "M597.84,817.27c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-2",
    "data-name": "bt",
    className: "ib-phase-2-17",
    d: "M599.4,817.4v-2.51h3.4v2.51h-3.4ZM599.4,832.61v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-2",
    "data-name": "bq",
    className: "ib-phase-2-17",
    d: "M617.06,829.35c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM614,824.67c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bv",
    className: "ib-phase-2-17",
    d: "M624.05,819.44c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM625.21,830.58c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M583.16,1103.46h-1v-29.1h1v29.1ZM584.01,1045.02h-1v-45h1v45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-12",
    d: "M584,1000.03h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M584.04,1000.06h-1.05v-.57h1.04v.57ZM583.04,999.54v.47h.95v-.47h-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-12",
    d: "M582.66,1118.23l-4.63-14.26h9.26l-4.63,14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M582.66,1119.86l-5.32-16.4h10.64l-5.32,16.4ZM578.71,1104.46l3.96,12.15,3.95-12.14h-7.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bw",
    className: "ib-phase-2-17",
    d: "M448.37,1064.57l-1.49-4.28h-6.38l-1.49,4.28h-3.53l6.11-16.84h4.14l6.11,16.84h-3.46ZM446.13,1057.65l-2.44-7.33c-.68,2.58-1.63,4.89-2.44,7.33h4.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx",
    className: "ib-phase-2-17",
    d: "M461.62,1051.4c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM460.19,1062.54c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx-2",
    "data-name": "bx",
    className: "ib-phase-2-17",
    d: "M476.49,1051.4c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM475.06,1062.54c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br-2",
    "data-name": "br",
    className: "ib-phase-2-17",
    d: "M491.36,1054.39c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by",
    className: "ib-phase-2-17",
    d: "M499.16,1051.4c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM499.1,1062.54c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bz",
    className: "ib-phase-2-17",
    d: "M515.26,1064.57h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-3",
    "data-name": "bq",
    className: "ib-phase-2-17",
    d: "M532.71,1061.31c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM529.65,1056.63c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bv-2",
    "data-name": "bv",
    className: "ib-phase-2-17",
    d: "M539.7,1051.4c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM540.86,1062.54c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bu-2",
    "data-name": "bu",
    className: "ib-phase-2-17",
    d: "M563.6,1049.23c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by-2",
    "data-name": "by",
    className: "ib-phase-2-17",
    d: "M570.94,1051.4c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM570.87,1062.54c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br-3",
    "data-name": "br",
    className: "ib-phase-2-17",
    d: "M587.5,1054.39c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bA",
    className: "ib-phase-2-17",
    d: "M596.26,1047.73c8.15-.48,15.14.34,15.01,8.28-.07,5.43-2.99,8.56-8.22,8.56h-6.79v-16.84ZM599.79,1061.86c5.02.48,7.94-1.22,7.94-5.84s-3.06-5.98-7.94-5.57v11.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-3",
    "data-name": "bt",
    className: "ib-phase-2-17",
    d: "M613.92,1049.36v-2.51h3.4v2.51h-3.4ZM613.92,1064.57v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB",
    className: "ib-phase-2-17",
    d: "M628.31,1055.2c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs-2",
    "data-name": "bs",
    className: "ib-phase-2-17",
    d: "M640.4,1064.37c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br-4",
    "data-name": "br",
    className: "ib-phase-2-17",
    d: "M649.84,1054.39c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-4",
    "data-name": "bt",
    className: "ib-phase-2-17",
    d: "M651.87,1049.36v-2.51h3.4v2.51h-3.4ZM651.87,1064.57v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC",
    className: "ib-phase-2-17",
    d: "M666.13,1051.4c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51ZM664.71,1062.54c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bD",
    className: "ib-phase-2-17",
    d: "M677.61,1064.84c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs-3",
    "data-name": "bs",
    className: "ib-phase-2-17",
    d: "M694.52,1064.37c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-5",
    "data-name": "bt",
    className: "ib-phase-2-17",
    d: "M696.49,1049.36v-2.51h3.4v2.51h-3.4ZM696.49,1064.57v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by-3",
    "data-name": "by",
    className: "ib-phase-2-17",
    d: "M709.05,1051.4c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM708.98,1062.54c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE",
    className: "ib-phase-2-17",
    d: "M725.62,1051.4c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-11",
    d: "M1137.28,302.06l-1.98,186.24h-363.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-8",
    d: "M1137.78,302.09h-1v-.52h1v.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-10",
    d: "M756.76,488.3l14.26-4.64v9.27l-14.26-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-16",
    d: "M334.58,29.56h66.93v35.1h-66.91l-.02-35.1Z"
  }), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "#ib-popup-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-21",
    d: "M169.02,684.93h32.06v20.28h-32.06v-20.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-18",
    d: "M169,705.32h32.06v20.86h-32.06v-20.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-2",
    d: "M201.08,684.93h32.96v20.87h-32.96v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-22",
    d: "M201.08,705.32h32.96v20.86h-32.96v-20.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-1",
    d: "M167.1,694.03h33.96v2.67h-33.96v-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-1",
    d: "M183.15,684.89v20.32h-2.95v-20.32h2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-6",
    d: "M215.88,684.99v20.33h-3.42v-20.33h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-6",
    d: "M233.84,697.16h-32.82v-3.42h32.82v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-5",
    d: "M183.33,705.3v20.95h-3.43v-20.96h3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-5",
    d: "M201.13,718.03h-32.1v-3.42h32.1v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-1",
    d: "M215.88,705.21v20.96h-3.42v-20.95h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-1",
    d: "M234.04,718.03h-33.02v-3.42h33.02v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-6",
    d: "M215.2,705.21v21h-2.07v-21h2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-6",
    d: "M234.06,717.36h-32.98v-2.08h32.98v2.08Z"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "#ib-popup-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-21",
    d: "M336.47,928.72h32.06v20.28h-32.06v-20.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-18",
    d: "M336.46,949.1h32.04v20.87h-32.04v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-2",
    d: "M368.53,928.72h32.96v20.87h-32.97v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-22",
    d: "M368.53,949.1h32.96v20.87h-32.97v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-1",
    d: "M334.56,937.82h33.94v2.67h-33.94v-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-1",
    d: "M350.6,928.68v20.32h-2.96v-20.32h2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-6",
    d: "M383.32,928.78v20.32h-3.42v-20.32h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-6",
    d: "M401.3,940.96h-32.83v-3.43h32.82v3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-5",
    d: "M350.78,949.09v20.95h-3.42v-20.95h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-5",
    d: "M368.58,961.82h-32.1v-3.42h32.1v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-1",
    d: "M383.32,949v20.96h-3.42v-20.96h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-1",
    d: "M401.5,961.82h-33.03v-3.42h33.02v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-6",
    d: "M382.65,949v21h-2.08v-21h2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-6",
    d: "M401.5,961.16h-32.97v-2.1h32.98v2.1Z"
  })))), _a || (_a = /*#__PURE__*/React.createElement("a", {
    xlinkHref: "#ib-popup-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-25",
    d: "M326.8,33.16h64.1v33.6h-64.1v-33.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-3",
    d: "M395.16,34.93l-68.72,34.63-2.3-4.56,68.72-34.63s2.3,4.56,2.3,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-13",
    d: "M394.04,32.86l-68.72,34.64-.68-1.35,68.72-34.63.68,1.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-3",
    d: "M391.9,69.56l-68.43-35.2,2.34-4.55,68.43,35.2-2.34,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-13",
    d: "M365.7,54.54l-42.23-21.73.63-1.22,42.23,21.73s-.63,1.22-.63,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-13",
    d: "M392.96,67.06l-24.66-12.7.67-1.28,24.65,12.68s-.66,1.3-.66,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-3",
    d: "M324.6,45.39h69.02v9.15h-69l-.02-9.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-3",
    d: "M363.43,31.46v36.2h-9.16V31.46h9.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-13",
    d: "M324.6,46.86h69.02v6.22h-69l-.02-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-2-13",
    d: "M362.04,32.65v34.85h-6.37v-34.85h6.37Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "ib-phase-2-15",
    x: 321.79,
    y: 27.86,
    width: 74.55,
    height: 4.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ib-phase-2-15",
    x: 321.94,
    y: 27.9,
    width: 4.36,
    height: 42.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ib-phase-2-15",
    x: 321.94,
    y: 67.21,
    width: 75.3,
    height: 5.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ib-phase-2-15",
    x: 391.47,
    y: 27.86,
    width: 5.51,
    height: 45.28
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbPhase2);
export default __webpack_public_path__ + "static/media/IB-Phase-2.37d9923663e4283d49256891b2d3a0f9.svg";
export { ForwardRef as ReactComponent };